import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const issueNavigatorProjectBusinessEmbedRoute: InvariantJiraRoute = {
	name: 'issue-navigator-core-embed',
	path: '/jira/core/projects/:projectKey/issues/embed',
};
